if (!window.Eurus.loadedScript.includes('c-product-grid.js')) {
  window.Eurus.loadedScript.push('c-product-grid.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductGrid', (sectionId) => ({
        sectionId: sectionId,
        currentTab: 1,
        select(index) {
          this.currentTab = index;
        }
      }));
    });
  });
}
